import React, { useEffect, useState } from "react";
import { ACCOUNT_TYPES, PHONE_REGEX } from "../../data/Constants";
import { toast } from "react-toastify";
import { useGetFetch } from "../../data/Queries";
import {
  subscriptionMember,
  // subscriptionPartialGet,
  // subscriptions,
  // subscriptionsGetKey,
  userGet,
  userGetKey,
} from "../../data/ApiEndpoints";
import Loader from "../ui/Loader";
// import Tabs from "../ui/Tabs";
import "../../styles/enquiry.css";
import userImage from "../../images/enquiry/user.png";
import LightTable from "../components-bootstrap/LightTable";
import { formatDate } from "../../utils/utilityfunc";
import ReactModal from "react-modal";
import ModalHeader from "../ModalHeader";
import { BASE_URL } from "../../data/BaseUrl";
import { useQueryClient } from "react-query";
import { getDataApi } from "../../data/axios";
import HelmetWrapper from "../../HelmetWrapper";

const SubscriptionDetails = () => {
  // const tabs = ["All Subscriptions", "Partial Payment Subscriptions"];
  // const [activeTab, setActiveTab] = useState(tabs[0]);
  const qClient = useQueryClient();
  const [paymentModal, setPaymentModal] = useState({
    status: false,
    data: null,
  });
  const [userPhone, setUserPhone] = useState();
  const [employeeNum, setEmployeeNum] = useState();
  const [step, setStep] = useState(0);
  const [isdata, setIsData] = useState(false);
  const [userFilters, setUsersFilters] = useState({ limit: "0" });
  const [userDetails, setUserDetails] = useState({});

  const {
    data: userData,
    isLoading: isLoadingUser,
    isFetching: isFetchingUser,
    refetch: refetchUser,
  } = useGetFetch({
    url: userGet,
    key: userGetKey,
    filters: userFilters,
    isPage: 1,
  });

  const [activeSubs, setActiveSubs] = useState([]);
  const [draftSubs, setDraftSubs] = useState([]);
  const [inActiveSubs, setInActiveSubs] = useState([]);

  function handleLogin() {
    try {
      if (!PHONE_REGEX.test(`${userPhone}`.trim())) {
        toast.error("Enter a valid 10 digit phone number!");
      } else {
        setUsersFilters({
          limit: "1",
          mobile: `${userPhone}`.trim(),
          is_token: 1,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleEmployeeLogin() {
    try {
      if (employeeNum && PHONE_REGEX.test(`${employeeNum}`.trim())) {
        const isUserValid = await getUser();
        if (isUserValid) {
          toast.success("Welcome!");
          setStep(step + 1);
        } else {
          toast.error("User Not Authorised!");
        }
      } else {
        toast.error("Enter a valid phone number!");
      }
    } catch (error) {
      console.log(error);
    }
  }

  function getMode(trx_id = "") {
    try {
      let id = trx_id;
      if (id.includes("/")) id = "cash/online";
      const trxType = {
        cash: "Cash",
        "cash/online": "Cash/Online",
      };
      const mode = trxType[id] || "Online";
      return mode;
    } catch (error) {
      console.log(error);
    }
  }

  const COLUMNS = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="flex-k fs-normal-k">{row?.gym_name || "N/A"}</span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Subscribed Plan",
      formatter: (_, row) => {
        return (
          <span className="flex-k fs-normal-k">
            {row?.plan_name || row?.addon_name || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (_, row) => {
        return (
          <span className="flex-k fs-normal-k">
            {formatDate(row?.start_date) || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (_, row) => {
        return (
          <span className="flex-k fs-normal-k">
            {formatDate(row?.expire_date) || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "trx_id",
      text: "Mode",
      formatter: (data) => {
        const mode = getMode(data);
        return (
          <div>
            <span className="bold-text">{mode}</span>
          </div>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "Type",
      formatter: (data) => {
        const isPartial =
          data === "true" || data === true || data === 1 || data === "1";
        return (
          <div>
            <span className="bold-text">
              {isPartial ? "Partial" : "Regular"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "partial_payment",
      text: "Payment Details",
      formatter: (data, row) => {
        const item = row?.is_partial;
        const isPartial =
          item === "true" || data === true || data === 1 || data === "1";
        return (
          <div>
            <button
              disabled={!isPartial}
              onClick={() =>
                setPaymentModal({
                  status: true,
                  data: data,
                })
              }
              className="btn-k table-link-k">
              View Details
            </button>
          </div>
        );
      },
    },
  ];

  const partialPaymentCols = [
    {
      dataField: "date",
      text: "Due Date",
      formatter: (_, row) => {
        return (
          <span className="flex-k fs-normal-k">
            {formatDate(row?.date) || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Paid On",
      formatter: (_, row) => {
        return (
          <span className="flex-k fs-normal-k">
            {formatDate(new Date(Number(row?.date_added))) || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (amount) => {
        return (
          <span className="flex-k fs-normal-k">{`₹${amount}` || "N/A"}</span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (status) => {
        return (
          <div className="flex-k capitalise-k">
            <span
              className={`flex-k fs-normal-k badge-k ${
                status === "completed" ? "green" : "red-bg-k"
              }`}>
              {status || "N/A"}
            </span>
          </div>
        );
      },
    },
  ];

  function hasAccess(user) {
    try {
      const allowedRoles = [
        ACCOUNT_TYPES.admin,
        ACCOUNT_TYPES.sales_executive,
        ACCOUNT_TYPES.gym,
        ACCOUNT_TYPES.trainer,
        ACCOUNT_TYPES.cluster_manager,
      ];
      if (allowedRoles.includes(user?.account_type)) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  }

  // Fetch Employee
  async function getUser() {
    try {
      const { data, status } = await getDataApi({
        url: `${BASE_URL}/user?=&is_token=1&mobile=${employeeNum.trim()}&limit=1`,
      });

      if (status) {
        if (hasAccess(data && data[0])) {
          setEmployeeNum(data && data[0]);
        } else {
          return false;
        }
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  // user Subscriptions ~
  async function getSubs(status) {
    try {
      const id = userDetails?.uid;
      const token = userDetails?.token;

      if (id) {
        setIsData(true);
        const res = await fetch(
          `${BASE_URL}${subscriptionMember}?member_id=${id}&subscription_status=${status}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.ok) {
          const data = await res.json();
          return data;
        } else {
          console.error(
            "Error fetching subscriptions:",
            res.status,
            res.statusText
          );
        }
        setIsData(false);
      }
    } catch (error) {
      console.error("Network error:", error.message);
    } finally {
      setIsData(false);
    }
  }

  // user Subscriptions ~
  async function setData() {
    try {
      const activeData = await getSubs("active");
      const inactiveData = await getSubs("inactive");
      const draftData = await getSubs("draft");

      if (activeData?.status) {
        setActiveSubs(activeData?.data);
      }
      if (inactiveData?.status) {
        setInActiveSubs(inactiveData?.data);
      }
      if (draftData?.status) {
        setDraftSubs(draftData?.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function isLoading() {
    try {
      if (isLoadingUser || isFetchingUser) {
        return true;
      }
      if (isdata) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  function handleLogout(n) {
    setActiveSubs([]);
    setDraftSubs([]);
    setInActiveSubs([]);
    // activeSubs([]);

    try {
      if (n === 1) {
        setStep(1);
        setUsersFilters({ limit: "0" });
        setUserPhone();
        setUserDetails();
      } else {
        setStep(0);
      }
      setEmployeeNum();
      qClient.removeQueries(userGetKey);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    try {
      refetchUser();
    } catch (error) {
      console.log(error);
    }
  }, [userFilters]);

  useEffect(() => {
    try {
      if (userDetails) {
        setData();
      }
    } catch (error) {
      console.log(error);
    }
  }, [userDetails]);

  useEffect(() => {
    try {
      if (userData?.status) {
        const user = userData?.data[0];
        setUserDetails(user);
        setStep(2);
      }
    } catch (error) {
      console.log(error);
    }
  }, [userData]);

  return (
    <HelmetWrapper title="WTF: Subscription Management">
      <main className="h-screen-k cloud-bg-k">
        {isLoading() ? (
          <div className="flex-k js-center-k items-center-k h-75vh-k">
            <Loader />
          </div>
        ) : (
          <div className="contain-wrapper">
            {step === 0 ? (
              <div>
                <div className="flex-k h-75vh-k contain-small flex-col-k js-center-k items-center-k">
                  <h3 className="bold-text">Check Membership Status</h3>
                  <div className="flex-k js-center-k items-center-k m-3 box-shadow-k rounded-2 p-3">
                    <div className="flex-k flex-col-k items-center-k gap-1-k my-1-k">
                      <div>
                        <label className="fs-normal-text bold-text mb-1">
                          Enter Your Registered Mobile Number*
                        </label>
                        {/* <label className="bold-text dark-text">Phone Number*</label> */}
                        <input
                          type="text"
                          className="input-k"
                          placeholder="Enter Your Mobile Number.."
                          value={employeeNum}
                          onChange={(e) => {
                            try {
                              setEmployeeNum(e?.target?.value);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        />
                      </div>
                      <button
                        onClick={handleEmployeeLogin}
                        className="btn-k large btn-primary-k">
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {step === 1 ? (
              <div className="flex-k h-75vh-k contain-small flex-col-k js-center-k items-center-k">
                <div className="flex-k js-between-k w-full-k mx-3 px-3">
                  <h3 className="bold-text">Check Membership Status</h3>
                  <button
                    onClick={() => handleLogout(0)}
                    className="btn-k btn-muted-k small">
                    Back
                  </button>
                </div>
                <div className="flex-k js-center-k items-center-k m-3 box-shadow-k rounded-2 p-3">
                  <div className="flex-k flex-col-k items-center-k gap-1-k my-1-k">
                    <div>
                      <label className="fs-normal-text bold-text mb-1">
                        Enter Member's Registered Mobile Number*
                      </label>
                      <input
                        type="text"
                        className="input-k"
                        placeholder="Member's Mobile Number.."
                        value={userPhone}
                        onChange={(e) => {
                          try {
                            setUserPhone(e?.target?.value);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                    </div>
                    <button
                      onClick={handleLogin}
                      className="btn-k large btn-primary-k">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            ) : null}

            {step === 2 ? (
              <>
                <div className="flex-k js-between-k items-center-k">
                  <h3 className="bold-text py-3">Membership Status</h3>
                  <button
                    onClick={() => handleLogout(1)}
                    className="btn-k btn-muted-k small">
                    Back
                  </button>
                </div>
                <div className="grid-k profile-details-wrapper grid-col-3-k">
                  <div className="user-profile-wrapper">
                    <img
                      className="rounded-full-k"
                      src={userImage}
                      alt="user"
                    />
                    <div className="flex-k js-center-k flex-col-k items-center-k text-white capitalise-k">
                      <span className="text-white bold-text">
                        {userDetails?.name}
                      </span>
                      <span className="text-white bold-text">
                        {userDetails?.account_type}
                      </span>
                    </div>
                  </div>
                  <div className="grid-span-2-k p-1 px-3">
                    <header className="profile-details-header">Details</header>
                    <div className="grid-k grid-col-2-k">
                      <div>
                        <p className="bold-text">Email: </p>
                        <p>{userDetails?.email || "N/A"}</p>
                      </div>
                      <div>
                        <p className="bold-text">Phone: </p>
                        <p>{userDetails?.mobile || "N/A"}</p>
                      </div>
                    </div>
                    <div className="grid-k grid-col-2-k">
                      <div className="flex-k gap-1-k capitalise-k">
                        <p className="bold-text">Status: </p>
                        <p>{userDetails?.status || "N/A"}</p>
                      </div>
                      <div className="flex-k gap-1-k">
                        <p className="bold-text">Gym Name: </p>
                        <p>{userDetails?.gym_name || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-3">
                  <>
                    <div className="my-4">
                      <span className=" badge-k fs-normal-k green">
                        Active Subscriptions
                      </span>
                      {activeSubs?.length > 0 ? (
                        <LightTable columns={COLUMNS} data={activeSubs || []} />
                      ) : (
                        <div className="my-3-k">
                          <span className="fs-normal-k bold-text">
                            No Active Subscriptions Found!!!
                          </span>
                        </div>
                      )}
                    </div>

                    <>
                      <div className="my-4">
                        <span className="badge-k fs-normal-k red-bg-k">
                          Inactive Subscriptions
                        </span>
                        {inActiveSubs?.length ? (
                          <LightTable
                            columns={COLUMNS}
                            data={inActiveSubs || []}
                          />
                        ) : (
                          <div className="my-3-k">
                            <span className="fs-normal-k bold-text">
                              No Inactive Subscriptions Found!
                            </span>
                          </div>
                        )}
                      </div>
                    </>

                    <div className="my-4">
                      <span className="badge-k fs-normal-k purple">
                        Draft Subscriptions
                      </span>
                      {draftSubs?.length ? (
                        <LightTable columns={COLUMNS} data={draftSubs || []} />
                      ) : (
                        <div className="my-3-k">
                          <span className="fs-normal-k bold-text">
                            No Draft Subscriptions Found!
                          </span>
                        </div>
                      )}
                    </div>
                  </>
                </div>
              </>
            ) : null}
          </div>
        )}

        <ReactModal ariaHideApp={false} isOpen={paymentModal?.status}>
          <div className="modal-body-k small bg-white rounded-4">
            <ModalHeader
              title={"Partial Payment Details"}
              onClick={() => setPaymentModal({ status: false, data: null })}
            />

            <div>
              <LightTable
                data={paymentModal?.data || []}
                columns={partialPaymentCols}
              />
            </div>
          </div>
        </ReactModal>
      </main>
    </HelmetWrapper>
  );
};

export default SubscriptionDetails;
